import { render, staticRenderFns } from "./editlink.vue?vue&type=template&id=bf3eedf0&scoped=true"
import script from "./editlink.vue?vue&type=script&lang=js"
export * from "./editlink.vue?vue&type=script&lang=js"
import style0 from "./editlink.vue?vue&type=style&index=0&id=bf3eedf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3eedf0",
  null
  
)

export default component.exports